<template>
    <div class="goods_type">
        <htmlHeader :top_index="1" :menuCode="false" :crumbsShow="false" @headSearchFun="clearQuery" />
        <div class="main">
            <div class="label-list">
                <div style="margin-right:10px">筛选条件></div>
                <div v-for="(item, key) in screening_list" :key="item.type" class="label">
                    <div>{{ item.name }}：</div>
                    <div class="value">{{ item.value }}</div>
                    <a-icon type="close" class="icon" @click="screen_getList([], key)" />
                </div>
                <div class="label-button">
                    <div @click="clearAll()">清空筛选</div>
                    <div class="switch-screen" @click="showScreen = !showScreen">
                        {{ showScreen ? '收起筛选' : '展开筛选' }}
                        <img src="../assets/arrow  down@2x.png" :class="showScreen ? 'rotate' : ''" alt="" />
                    </div>
                </div>
            </div>
            <div class="screen" v-show="showScreen">
                <screen title="品牌" :list="type_allAvailable" @checked="brand_screen" />
                <screen title="一级分类" :list="allAvailableTree" @checked="level_1_screen" />
                <screen title="二级分类" :list="level_2_list" @checked="level_2_screen" />
                <screen title="三级分类" :list="level_3_list" @checked="level_3_screen" />
                <screen2 @checked="advanced_screen" />
                <screen title="排序" :list="sort_list" @checked="sort_screen" :banCheckbox="true" />
            </div>
            <div style="margin-bottom:20px">
                <commodityList v-for="item in dataList" :key="item.uuid" :data="item" :screening="screening" />
                <!-- <a-pagination :defaultPageSize="5" :page-size-options="pageSizeOptions" show-size-changer v-model="page" :total="totalElements" @showSizeChange="onShowSizeChange" @change="onShowSizeChange" style="text-align: center;" /> -->
                <a-pagination  :page-size-options="pageSizeOptions" show-size-changer v-model="page" :total="totalElements" @showSizeChange="onShowSizeChange" @change="onShowSizeChange" style="text-align: center;" />
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
const sort_list = [
    {
        name: '综合排序',
        id: 'HOT_SALES'
    },
    {
        name: '新品',
        id: 'NEW'
    },
    {
        name: '促销',
        id: 'PROMOTION'
    },
    {
        name: '销量',
        id: 'SALES'
    },
    {
        name: '价格升序',
        id: 'PRICE_ASC'
    },
    {
        name: '价格降序',
        id: 'PRICE_DESC'
    }
];
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import screen from './productList/screen.vue';
import screen2 from './productList/screen2.vue';
import commodityList from './productList/commodityList.vue';
export default {
    components: {
        userLeft,
        htmlHeader,
        foot,
        screen,
        screen2,
        commodityList
    },
    data() {
        return {
            type_allAvailable: [], //品牌列表
            allAvailableTree: [], //一二三级分类
            level_2_list: [],
            level_3_list: [],
            level_3_list: [],
            store_list: [],
            totalElements: 0,
            sort_list,
            page: 1,
            showScreen: true,
            pageSizeOptions: ['10', '20', '30', '40'],
            screening: {
                sort: 'HOT_SALES',
                search: '',
                typeAccuracy: '',
                brandName: [],
                category1: [],
                category2: [],
                category3: [],
                deliveryTimeStatus: '',
                packaging: [],
                priceMin: '',
                priceMax: '',
                storeIdArray: '',
                size: '10',
                page: '0'
            },
            screening_list: {},
            dataList: []
        };
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    methods: {
        init() {
            this.get_goods_type_allAvailable();
            this.get_allAvailableTree();
            this.clearQuery();
            // this.screening.search = this.$route.query.search;
        },
        onShowSizeChange(current, size) {
            console.log(current, size);
            this.screening.size = size;
            this.screening.page = current - 1;
            this.get_goods_list();
        },
        clearAll() {
            this.screening = {
                sort: 'HOT_SALES',
                search: '',
                typeAccuracy: '',
                brandName: [],
                category1: [],
                category2: [],
                category3: [],
                deliveryTimeStatus: '',
                packaging: [],
                priceMin: '',
                priceMax: '',
                storeIdArray: '',
                size: this.screening.size,
                page: '0'
            };
            this.page = 1;
            this.screening_list = {};
            this.get_goods_list();
        },
        // 商品列表
        get_goods_list() {
            this.api.goods_list(this.screening).then(res => {
                this.totalElements = res.data.totalElements;
                this.dataList = res.data.content;
            });
        },
        // 获取分类 ---- 品牌
        get_goods_type_allAvailable() {
            this.api.get_goods_type_allAvailable().then(res => {
                if (res.ok) {
                    res.data.forEach(i => (i.checked = false));
                    this.type_allAvailable = [...res.data];
                }
            });
        },
        // 所有分类
        get_allAvailableTree() {
            this.api.get_allAvailableTree().then(res => {
                res.data.forEach(i => (i.checked = false));
                this.allAvailableTree = res.data;
            });
        },
        //筛选条件---品牌
        brand_screen(e) {
            this.screen_getList(e, 'brandName', '品牌');
        },
        //筛选条件---一级分类
        level_1_screen(e) {
            console.log(e);
            this.level_2_list = [];
            this.level_3_list = [];
            if (e.length == 0 || e[0].id == 'all') {
                this.allAvailableTree.forEach(item => {
                    this.level_2_list.push(...item.children);
                });
            } else {
                e.forEach(item => {
                    this.level_2_list.push(...item.children);
                });
            }
            this.screen_getList(e, 'category1', '一级分类');
            if (this.screening_list.category2) {
                delete this.screening_list.category2;
            }
            if (this.screening_list.category3) {
                delete this.screening_list.category3;
            }
        },
        //筛选条件---二级分类
        level_2_screen(e) {
            console.log(e);
            this.level_3_list = [];
            if (e[0].id == 'all') {
                this.level_2_list.forEach(item => {
                    this.level_3_list.push(...item.children);
                });
            } else {
                e.forEach(item => {
                    this.level_3_list.push(...item.children);
                });
            }
            this.screen_getList(e, 'category2', '二级分类');
            if (this.screening_list.category3) {
                delete this.screening_list.category3;
            }
        },
        //筛选条件---三级分类
        level_3_screen(e) {
            console.log(e);
            this.screen_getList(e, 'category3', '三级分类');
        },
        //筛选条件---高级选项
        advanced_screen(e, type) {
            let name = '';
            console.log(type);
            if (type == 'packaging') {
                name = '包装';
            } else if (type == 'deliveryTimeStatus') {
                name = '交期';
            } else if (type == 'price') {
                name = '价格';
            } else if (type == 'storeIdArray') {
                name = '所属商家';
            } else if (type == 'goodsPackage') {
                name = '包装材料';
            } else if (type == 'packagingNew') {
                name = '级别';
            }
            this.screen_getList(e, type, name);
        },
        clearQuery() {
            if (this.$route.query.search) {
                if (this.$route.query.typeAccuracy) {
                    this.screening.typeAccuracy = this.$route.query.typeAccuracy;
                } else {
                    this.screening.typeAccuracy = '';
                }
                this.screen_getList(
                    [
                        {
                            id: this.$route.query.search,
                            name: this.$route.query.search
                        }
                    ],
                    'search',
                    '关键字'
                );
            } else {
                this.screening.typeAccuracy = '';
                this.screening.search = '';
                this.get_goods_list();
            }
        },
        sort_screen(e) {
            console.log(e);
            this.screening.sort = e[0].id;
            this.get_goods_list();
        },
        screen_getList(e, type, name) {
            if (e.length == 0 && type == 'search') {
                this.screening.typeAccuracy = '';
            }
            let list = [];
            if (type == 'price') {
                this.screening.priceMin = [];
                this.screening.priceMax = [];
            } else {
                this.screening[type] = [];
            }
            if (e.length && e[0].id != 'all') {
                if (type == 'price') {
                    e.forEach(item => {
                        this.screening.priceMin = item.id.min;
                        this.screening.priceMax = item.id.max;
                        list.push(item.name);
                    });
                } else if (type == 'search') {
                    this.screening.search = e[0].id;
                    list.push(e[0].name);
                }else if(type == 'packagingNew'){
                 e.forEach(item => {
                        this.screening.packagingNew.push(item.uuid);
                        list.push(item.name);
                    });
                } else {
                    e.forEach(item => {
                        this.screening[type].push(item.id);
                        list.push(item.name);
                    });
                }
                this.$set(this.screening_list, type, {
                    name,
                    value: list.join('、')
                });
            } else {
                delete this.screening_list[type];
            }
            this.get_goods_list();
        }
    }
};
</script>

<style lang="less" scoped>
.goods_type {
    .main {
        width: 1200px;
        margin: auto;
        .label-list {
            display: flex;
            line-height: 24px;
            width: 1200px;
            position: relative;
            padding: 12px 0;
            cursor: default;
            flex-wrap: wrap;
            .label {
                display: flex;
                height: 24px;
                // line-height: 24px;
                background: #f4f4f4;
                border: 1px solid #ede9e9;
                margin-right: 8px;
                padding: 0 5px;
                .value {
                    color: #2b9a34;
                }
                .icon {
                    margin: auto 0;
                    font-size: 7px;
                    color: #666666;
                    margin-left: 2px;
                }
            }
            .label-button {
                display: flex;
                position: absolute;
                right: 10px;
                font-size: 12px;
                color: #333333;
                .switch-screen {
                    // width: 72px;
                    height: 24px;
                    border: 1px solid #ede9e9;
                    margin-left: 10px;
                    padding: 0 5px;
                    display: flex;
                    img {
                        width: 9px;
                        height: 5px;
                        margin: auto 0;
                        margin-left: 5px;
                    }
                }
            }
        }
        .screen {
            margin-bottom: 20px;
            border-top: 1px solid #999;
        }
    }
}
.rotate {
    transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/goods_type.vue